import { render } from "./TreeBrowser.vue?vue&type=template&id=ff3908d4&scoped=true"
import script from "./TreeBrowser.vue?vue&type=script&lang=js"
export * from "./TreeBrowser.vue?vue&type=script&lang=js"

import "./TreeBrowser.vue?vue&type=style&index=0&id=ff3908d4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3908d4"]])

export default __exports__